<script>
  import { frameContainer } from "../../app.styles";
  import { css } from "emotion";
  import {
    containerWrapper,
    titleSection,
    formContainer,
    imgWrapper,
    formImg,
    whiteBoxWrapper,
    whiteBox,
  } from "./superyou.style";
  import BaseInput from "../../components/BaseInput/BaseInput.svelte";
  import BaseButton from "../../components/BaseButton/BaseButton.svelte";
  import FormSubmitResponse from "../../containers/LeadGenForm/FormSubmitResponse.svelte";
  import browserdetection from "../../utils/BrowserDetection";

  import RightArrow from "../../svg/RightArrow.svelte";
  import LoadingBullet from "../../svg/LoadingBullet.svelte";

  import { fade } from "svelte/transition";

  export let clientKey;
  const leadgen_api_url = process.env.LEADGEN_API_URL;

  let fieldsValue = {
    name: "",
    phone: "",
    email: "",
  };

  let errFields = {
    name: {
      required: true,
      status: false,
      msg: "",
      fieldName: "Nama",
    },
    phone: {
      required: true,
      status: false,
      msg: "",
      fieldName: "Nomor Handphone",
    },
    email: {
      required: true,
      status: false,
      msg: "",
      fieldName: "Email",
    },
  };

  let preventInputCharAndLength = {
    name: {
      max: 60,
      min: 3,
      char: "^[A-Za-z ]+$",
    },
    phone: {
      max: 15,
      min: 4,
      char: "^[0-9]*$",
    },
  };

  let isBtnLoading = false;
  let isSubmittedSucces = false;

  let submitResponse = {
    success: true,
    title: "Berhasil",
    message:
      "Terimakasih telah mengisi data kamu, tim kami akan segera mengubungi kamu kembali",
  };

  const beforeInput = (e) => {
    const { value, name } = e.target;
    if (
      value.length >= preventInputCharAndLength[name].max &&
      e.inputType !== "deleteContentBackward"
    ) {
      e.preventDefault();
      return false;
    }

    checkCharRegexMatch(e, name);
  };

  const keyPress = (e) => {
    if (browserdetection() === "firefox") {
      beforeInput(e);
    }
  };

  const handleInputChange = (e) => {
    const { value, name } = e.target;
    fieldsValue = {
      ...fieldsValue,
      [name]: value,
    };
  };

  const checkCharRegexMatch = (e, name) => {
    if (!preventInputCharAndLength[name].char) return;

    const rgx = new RegExp(preventInputCharAndLength[name].char);
    let inputVal = e.data || e.key;
    if (rgx.test(inputVal) || e.inputType === "deleteContentBackward") {
      return true;
    }
    e.preventDefault();
    return false;
  };

  const checkEmailFormat = (mail) => {
    let mail_regex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (mail_regex.test(mail)) {
      return true;
    }
    return false;
  };

  const checkAllFieldValid = (fields) => {
    let isValid = true;

    for (const [key, field] of Object.entries(fields)) {
      if (field.status) {
        isValid = false;
        break;
      }
    }

    return isValid;
  };

  const onSubmitErrorHandler = () => {
    const fields = Object.keys(fieldsValue);

    fields.forEach((fieldName) => {
      const val = fieldsValue[fieldName];

      // Check field value required
      if (errFields[fieldName].required && val === "" && !val.length) {
        const err = errFields[fieldName];
        errFields[fieldName] = {
          ...err,
          status: true,
          msg: `${errFields[fieldName].fieldName} harus diisi`,
        };

        return;
      }

      // Check Min Character at each field
      if (
        preventInputCharAndLength[fieldName] &&
        val.length <= preventInputCharAndLength[fieldName].min
      ) {
        const err = errFields[fieldName];
        errFields[fieldName] = {
          ...err,
          status: true,
          msg: `Min karakter ${preventInputCharAndLength[fieldName].min}`,
        };

        return;
      }

      // Check format email
      if (fieldName === "email" && !checkEmailFormat(val)) {
        const err = errFields[fieldName];
        errFields[fieldName] = {
          ...err,
          status: true,
          msg: `Format email tidak valid`,
        };

        return;
      }

      // if valid set error field to false
      errFields[fieldName] = {
        ...errFields[fieldName],
        status: false,
        msg: "",
      };
    });

    if (checkAllFieldValid(errFields)) {
      isBtnLoading = true;

      fetch(`${leadgen_api_url}/auth/add-new-customer?key=${clientKey}`, {
        method: "POST",
        body: JSON.stringify({
          full_name: fieldsValue.name,
          mobile_number: fieldsValue.phone,
          email: fieldsValue.email,
          entrance_channel: "superyou",
        }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          if (res.status === 200) {
            isSubmittedSucces = true;
          } else if (res.status === 403) {
            console.log(res);
            submitResponse = {
              success: false,
              title: "Gagal",
              message: `${res.status} ${res.statusText}`,
            };
            isSubmittedSucces = true;
          }
        })
        .catch((error) => {
          console.log("Request failed", error);
          submitResponse = {
            success: false,
            title: "Gagal",
            message: `Internal server error, mohon dapat mencoba kembali beberapa saat kemudian`,
          };
          isSubmittedSucces = true;
        });
    }
  };
</script>

<div class={frameContainer}>
  <div class={containerWrapper}>
    <h2 class={titleSection}>
      Kamu juga bisa meninggalkan kontak untuk kami hubungi dan bertanya lebih
      lanjut
    </h2>

    <div class={formContainer}>
      <div class={imgWrapper}>
        <img
          class={formImg}
          src={`${process.env.APP_URL}/img/social-queen.png`}
          alt="social queen" />
      </div>
      <div class={whiteBoxWrapper}>
        <div class={whiteBox}>
          {#if !isSubmittedSucces}
            <form
              style="width: 100%;"
              on:submit|preventDefault={onSubmitErrorHandler}
              transition:fade={{ duration: 500 }}>
              <BaseInput
                name="name"
                label="Nama"
                type="text"
                on:beforeinput={beforeInput}
                on:keypress={keyPress}
                on:input={handleInputChange}
                inputValue={fieldsValue.name}
                error={errFields.name} />
              <br />
              <BaseInput
                name="phone"
                label="Handphone"
                type="tel"
                on:beforeinput={beforeInput}
                on:keypress={keyPress}
                on:input={handleInputChange}
                inputValue={fieldsValue.phone}
                error={errFields.phone} />
              <br />
              <BaseInput
                name="email"
                label="Email"
                type="text"
                on:input={handleInputChange}
                inputValue={fieldsValue.email}
                error={errFields.email} />
              <br />

              <BaseButton
                textAlign={isBtnLoading ? 'text-center' : 'text-left'}
                style={css`
                  font-size: 13px;
                  margin-top: 10px;
                  padding: 16px;
                  max-width: 320px;`}>
                {#if !isBtnLoading}
                  HUBUNGI SAYA
                  <RightArrow />
                {:else}
                  <LoadingBullet />
                {/if}
              </BaseButton>
            </form>
          {:else}
            <div transition:fade={{ delay: 500 }}>
              <FormSubmitResponse {submitResponse} />
            </div>
          {/if}
        </div>
      </div>
    </div>
  </div>
</div>
